import { createConsumer } from "@rails/actioncable"

class MixChannelSubscription {
  constructor() {
    this.cable = null
    this.subscription = null
    this.callbacks = {} // { 'note': [callback1, callback2], 'marker': [callback3] }
  }

  subscribe() {
    if (this.subscription) {
      return
    }

    if (!this.cable) {
      this.cable = createConsumer()
    }

    const channelName = mmmGlobals.logged_in ? "UserChannel" : "MixChannel"
    this.subscription = this.cable.subscriptions.create(channelName, {
      received: (data) => {
        console.log("Received actioncable channel update:", data)

        // Fan out to callbacks registered for this data type
        if (data.type && this.callbacks[data.type]) {
          this.callbacks[data.type].forEach(callback => {
            callback(data)
          })
        }
      }
    })
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  registerCallback(type, callback) {
    if (!this.callbacks[type]) {
      this.callbacks[type] = []
    }
    this.callbacks[type].push(callback)

    this.subscribe()
  }

  unregisterCallback(type, callback) {
    if (!this.callbacks[type]) {
      return
    }

    const index = this.callbacks[type].indexOf(callback)
    if (index > -1) {
      this.callbacks[type].splice(index, 1)
    }
  }
}

const subscription = new MixChannelSubscription()
export default subscription
